// src/components/challenge/challenge.component.js
import React, { Component } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
//import ComingSoonm from "../menu/comingsoonm.component";
import styled, { createGlobalStyle } from "styled-components";
import ReactGA from "react-ga4";

const GlobalStyle = createGlobalStyle`
  body {
    padding: 0;
    margin: 0;
    overflow: hidden;
    align-items: center;
  }
  .p-challenge {
    word-break: break-word;
    overflow-wrap: break-word;
  }
`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  min-height: 100vh;
  background: linear-gradient(45deg, #1d9bf0, #ff0080, #4c00ff, #ff7b00);
  background-size: 400% 400%;
  animation: gradientRotate 15s ease infinite;

  @keyframes gradientRotate {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
  flex-wrap: wrap;
  padding-top: 10px;
  width: 100%;
  max-width: 800px;
`;

const ChallengeCard = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  padding: 20px;
  margin: 20px;
  width: 90%;
  max-width: 600px;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const ChallengeTitle = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
`;

const ChallengeDescription = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 20px;
`;

const JoinButton = styled.button`
  background-color: #1d9bf0;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  margin-top: 10px;

  &:hover {
    background-color: #0d8bd0;
  }
`;

class Challenge extends Component {
  constructor(props) {
    super(props);

    // Get challenge ID from URL params
    const challengeId = this.props.match.params.id;

    this.state = {
      challenge: {
        id: challengeId || "default",
        title: "30-Day Fitness Challenge",
        description:
          "Join our 30-day fitness challenge to transform your body and mind. This challenge includes daily workouts, nutrition tips, and community support.",
        imageUrl:
          //"https://www.bealyo.com/images/challenges/fitness-challenge.jpg",
          "https://www.bealyo.com/images/prebealyoshare.png",
        startDate: "2025-01-01",
        endDate: "2025-01-30",
        participants: 1245,
      },
    };
  }

  componentDidMount() {
    const challengeId = this.props.match.params.id;

    console.log("Challenge ID:", challengeId);

    // Track page view
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });

    // Fetch challenge data from API
    axios
      .get(process.env.REACT_APP_API_URL + "goals/" + challengeId)
      .then((response) => {
        const goalData = response.data;

        // Map API response to challenge state
        this.setState({
          challenge: {
            id: goalData._id,
            title: goalData.goal_title,
            description: goalData.goal_desc,
            imageUrl: process.env.REACT_APP_IMG_FOLDER + goalData.goal_imageurl,
            startDate: new Date(goalData.goal_start_date).toLocaleDateString(),
            endDate: new Date(goalData.goal_duedate).toLocaleDateString(),
            participants: goalData.num_users || 0,
            inviteId: goalData.goal_inviteid,
          },
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching challenge:", error);
        this.setState({
          error: "Failed to load challenge details",
          loading: false,
        });
      });
  }

  handleJoinClick = (chid) => {
    ReactGA.event({
      category: "Challenge",
      action: "Join Challenge Click",
      label: this.state.challenge.title,
    });
    //window.location.href = "/comingsoon";
    window.location.href = "http://www.bealyo.com/challenge/" + chid;
  };

  render() {
    const { challenge } = this.state;
    const shareUrl = `https://www.bealyo.com/challenge/${challenge.id}`;

    return (
      <PageContainer>
        <Helmet>
          <title>{challenge.title} | Bealyo</title>
          <meta name="description" content={challenge.description} />

          {/* App Links for Android */}
          <meta property="al:android:package" content="com.bealyo.bealyoapp" />
          <meta
            property="al:android:url"
            content={`bealyo-app://challenge/${challenge.id}`}
          />
          <meta property="al:android:app_name" content="Bealyo" />

          {/* iOS App Links */}
          <meta
            property="al:ios:url"
            content={`bealyo-app://challenge/${challenge.id}`}
          />
          <meta property="al:ios:app_store_id" content="YOUR_APP_STORE_ID" />
          <meta property="al:ios:app_name" content="Bealyo" />

          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content={shareUrl} />
          <meta property="og:title" content={challenge.title} />
          <meta property="og:description" content={challenge.description} />
          <meta property="og:image" content={challenge.imageUrl} />

          {/* Twitter */}
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content={shareUrl} />
          <meta property="twitter:title" content={challenge.title} />
          <meta
            property="twitter:description"
            content={challenge.description}
          />
          <meta property="twitter:image" content={challenge.imageUrl} />
        </Helmet>

        <GlobalStyle />
        <CenteredContainer>
          <ChallengeCard>
            <ChallengeTitle>{challenge.title}</ChallengeTitle>
            <img
              src={challenge.imageUrl}
              alt={challenge.title}
              style={{
                width: "80%", // Change from 100% to desired width
                maxHeight: "300px", // Add maximum height
                objectFit: "contain", // Maintain aspect ratio
                borderRadius: "5px",
                marginBottom: "15px",
                display: "block",
                margin: "0 auto 15px auto", // Center the image
              }}
            />
            <ChallengeDescription>{challenge.description}</ChallengeDescription>
            <p>
              Start Date: {challenge.startDate} * End Date: {challenge.endDate}{" "}
              * Participants: {challenge.participants}
            </p>
            <JoinButton onClick={() => this.handleJoinClick(challenge.id)}>
              Join This Challenge
            </JoinButton>
          </ChallengeCard>
        </CenteredContainer>
      </PageContainer>
    );
  }
}

export default Challenge;
